$(function() {

    $.fn.setCursorPosition = function(pos) {
        if ($(this).get(0).setSelectionRange) {
          $(this).get(0).setSelectionRange(pos, pos);
        } else if ($(this).get(0).createTextRange) {
          var range = $(this).get(0).createTextRange();
          range.collapse(true);
          range.moveEnd('character', pos);
          range.moveStart('character', pos);
          range.select();
        }
    };


    

    const $formClear = $('.js-form__clear'),
          $fromInput = $('.js-from__input');

    $formClear.on('click', function() {
        $(this).prev().val('');
        $(this).removeClass('active');
    });

    $fromInput.on('keyup', function() {
        console.log($(this).val())
        if($(this).val().length > 0 ) {
           return $(this).next().addClass('active');
        }
        $(this).next().removeClass('active');
    });

    const $select = $('.js-select');

    $select.styler();

    $('input[name="phone"]').mask("+7 ( 999 ) 999 - 99 99").on('click', function(){
        $(this).setCursorPosition(4);
    });

})